export default async function getBuoys(
    lat,
    lng,
    buoyMarkers,
    setBuoyMarkers,
    setLoading
) {
    console.log({ lat, lng });

    console.log(process.env.REACT_APP_API_SERVER);
    try {
        setLoading(true);
        const res = await fetch(
            `${process.env.REACT_APP_API_SERVER}/nearby-buoys/${lat}/${lng}`,
            // `${process.env.REACT_APP_API_SERVER}/wavedata/lat/${lat}/lng/${lng}`,
            {
                credentials: "include",
            }
        );
        let buoys = await res.json();

        setLoading(false);
        setBuoyMarkers(buoys);

        return;
    } catch (err) {
        setLoading(false);

        console.error("err");
        console.log(err);
        console.log("Cannot get Buoy data");
    }
}
